import React, { useState, useEffect, useRef } from "react";
import { dateCalculation } from "../../../utils";
import "./styles.css";
import activeDeal from "../../../images/activeDeal.svg";
import seatBooked from "../../../images/seatBooked.svg";
import profit from "../../../images/profit.svg";
import amountSpent from "../../../images/amountSpent.svg";
import actions from "../../../images/actions.svg";
import switchOn from "../../../images/switchOn.svg";
import switchOff from "../../../images/switchOff.svg";
import Button from "../../../components/common/button";
import RupeeIcon from "../../../images/rupee.svg";
import TablePagination from "../../../components/common/tablePagination";

const OngoingDeals = ({
  fetchDealSummary = () => {},
  dealsSummaryData = {},
  selectedDuration = "",
  getDealData = {},
  dealsData = [],
  actionButtonStyle,
  onEditDealsClick,
  onRefreshDealClick,
  onDisableDealsClick,
  dealsListLoading,
}) => {
  const [selectedFilter, setSelectedFilter] = useState("ALL");
  const [pageNum, setPageNum] = useState(1);
  const [paginationLimit, setPaginationLimit] = useState(10);
  const [activeTab, setActiveTab] = useState("active");
  const [dealsFilteredData, setDealsFilteredData] = useState([]);

 const onPageNumClick = (page) => {
  setPageNum(page);
  };
  // const summaryTiles = [];

  // let getDealsSummaryData1 = {
  //   summary: {
  //     "Active Deals": 317,
  //     "Seats Booked": 4300,
  //     "Total GMV generated": 25700,
  //     "Amount spent": 1753,
  //   },
  // };

  // useEffect(() => {
  //   const date = dateCalculation(selectedDuration);
  //   const { startDate, endDate } = date;
  //   const data = {
  //     from_time: startDate,
  //     to_time: endDate,
  //     deal_type: "EARLY_BIRD",
  //   };
  //   fetchDealSummary(data);
  // }, []);

  useEffect(() => {
    setDealsFilteredData(
      dealsData.filter((el) =>
        activeTab === "active" ? el.is_active : !el.is_active
      )
    );
  }, [activeTab, dealsData]);

  const handleFilterChange = (event) => {
    setSelectedFilter(event);
    if (event === "ALL") {
      // If the selected filter is "ALL", reset to the original dealsData
      setDealsFilteredData(
        dealsData.filter((el) =>
          activeTab === "active" ? el.is_active : !el.is_active
        )
      );
    } else {
      // If the selected filter is not "ALL", filter based on the selected deal_type
      const filteredDeals = dealsData.filter(
        (deal) => deal.deal_type === event
      );
      setDealsFilteredData(
        filteredDeals.filter((el) =>
          activeTab === "active" ? el.is_active : !el.is_active
        )
      );
    }
  };

  useEffect(() => {
    // if (dealsFilteredData.length === 0) {
    //   getDealsSummaryData1 = {
    //     summary: {
    //       "Active Deals": 317,
    //       "Seats Booked": 4300,
    //       "Total GMV generated": 25700,
    //       "Amount spent": 1753,
    //     },
    //   };
    // }
    const data = {
      deal_ids: dealsFilteredData.map((el) => el.deal_id),
    };
    fetchDealSummary(data);
  }, [dealsFilteredData]);

  const changeTab = (e) => {
    setActiveTab(e.target.value);
    setPageNum(1);
  };

  const onPrevClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setPageNum((prevPageNum) => prevPageNum - 1);
  };

  const onNextClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    if (dealsFilteredData.length > pageNum * paginationLimit) {
      setPageNum((prevPageNum) => prevPageNum + 1);
    }
  };

  const getElementName = (item) => {
    if (item === "seat_sold") {
      return "Seats booked";
    }
    if (item === "deal_count") {
      return "Active deals";
    }
    if (item === "amount_spent") {
      return "Amount spent";
    }
    if (item === "total_revenue_generated") {
      return "Total GMV generated";
    }
  };

  const formatValue = (key, value) => {
    if (key === "amount_spent" || key === "total_revenue_generated") {
      const formattedValue = Number(value).toLocaleString('en-IN', {
        style: 'currency',
        currency: 'INR'
      });
      return formattedValue !== '₹NaN'  ? formattedValue : '-';
    } else {
      return value || '-';
    }
  };

  const formatDateRange = (startDate, endDate) => {
    const [startYear, startMonth, startDay] = startDate.split('-');
    const [endYear, endMonth, endDay] = endDate.split('-');
  
    const months = [
      'January', 'February', 'March', 'April',
      'May', 'June', 'July', 'August',
      'September', 'October', 'November', 'December'
    ];
  
    const formattedStartDate = `${parseInt(startDay, 10)} ${months[parseInt(startMonth, 10) - 1]}`;
    const formattedEndDate = `${parseInt(endDay, 10)} ${months[parseInt(endMonth, 10) - 1]}`;
    // const formattedStartDate = `${parseInt(startDay, 10)} ${months[parseInt(startMonth, 10) - 1]} ${startYear}`;
    // const formattedEndDate = `${parseInt(endDay, 10)} ${months[parseInt(endMonth, 10) - 1]} ${endYear}`;
  
    return `${formattedStartDate} to ${formattedEndDate}`;
  };

  let temp = [];
  if(Object.keys(dealsSummaryData).length > 0) {
    temp.push(["deal_count", dealsSummaryData["summary"].deal_count]);
    temp.push(["seat_sold", dealsSummaryData["summary"].seat_sold]);
    temp.push(["total_revenue_generated", dealsSummaryData["summary"].total_revenue_generated]);
    temp.push(["amount_spent", dealsSummaryData["summary"].amount_spent]);
  }
  return (
    getDealData &&
    getDealData.dealTypes &&
    getDealData.dealTypes.length > 0 ? (
      <div className="dealsContainer">
        <div className="dealsTop">
          <div className="filterContainer">
            <div className="filterData" htmlFor="filterSelect">
              Deal Type
            </div>
            <div id="filterSelect" value={selectedFilter}>
              <span
                onClick={() => handleFilterChange("ALL")}
                className={`filterOption ${
                  selectedFilter === "ALL" ? "filterDataSelected" : ""
                }`}
                value="ALL"
              >
                ALL
              </span>
              {getDealData.dealTypes.map((option) => (
                <span
                  className={`filterOption ${
                    selectedFilter === option.type ? "filterDataSelected" : ""
                  }`}
                  key={option.type}
                  value={option.label}
                  onClick={() => handleFilterChange(option.type)}
                >
                  {option.label}
                </span>
              ))}
            </div>
          </div>
          {
            <div className="durationBlock dealStatus">
              <label htmlFor="durationSelect" className="durationLable">
                Deal status
              </label>
              <select
                className="durationOptionOnGoing"
                id="durationSelect"
                value={activeTab}
                onChange={(e) => changeTab(e)}
              >
                <option value="active">Active</option>
                <option value="disabled">Disabled</option>
              </select>
            </div>
          }
        </div>

        {Object.keys(dealsSummaryData).length > 0 && (
          <div className="dealContainer1">
            {temp.map((elem, index) => (
              <div key={index}>
                <div className="dealBlck">
                  {index === 0 && <img src={activeDeal} alt="Active Deal" />}
                  {index === 1 && <img src={seatBooked} alt="Seat Booked" />}
                  {index === 2 && <img src={profit} alt="Profit" />}
                  {index === 3 && <img src={amountSpent} alt="Amount Spent" />}
                  <div className="dataSection">
                    <div className="dealData1">{formatValue(elem[0], elem[1])}</div>
                    <div className="dealData2">{getElementName(elem[0])}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {
          <div className="ongoing-deals">
            <table className="deals-table">
              <thead>
                <tr className="deals-table-header">
                  <th className="tableData">Name</th>
                  <th className="tableData">Duration</th>
                  <th className="tableData">Route</th>
                  <th className="tableData">Tickets Booked</th>
                  <th className="tableData">GMV generated</th>
                  <th className="tableData">Status</th>
                  <th className="tableData">Action</th>
                </tr>
              </thead>
              <tbody>
                {!dealsFilteredData.length && dealsListLoading && (
                  <tr>
                    <td colSpan={7} className="table-no-data">
                      Please wait, Loading Deals...
                    </td>
                  </tr>
                )}
                {!dealsFilteredData.length && !dealsListLoading && (
                  <tr>
                    <td colSpan={7} className="table-no-data">
                      No Data Found
                    </td>
                  </tr>
                )}
                {dealsFilteredData &&
                  dealsFilteredData
                    .slice(
                      (pageNum - 1) * paginationLimit,
                      pageNum * paginationLimit
                    )
                    .map((el, i) => (
                      <tr key={el.deal_id} className="payout-table-row">
                        <td>{el.display_text}</td>
                        <td>
                          {formatDateRange(el.start_date,el.end_date)}
                        </td>
                        <td>
                          {el.service_ids[0] === "ALL"
                            ? "All Routes"
                            : el.deal_type === 'SEAT_LEVEL' && el.service_ids[0] ? `${el.src_city_name || ""} - ${
                                el.dest_city_name || ""
                              } - ${el.service_ids[0]}` : `${el.src_city_name || ""} - ${
                                el.dest_city_name || ""
                              }`}
                        </td>
                        <td>{el.tickets_booked || 0}</td>
                        <td>
                        {el.gmv_generated > 0 && <img
                            className="rupee-icon"
                            alt="Rupee-Icon"
                            src={RupeeIcon}
                          />}
                          {el.gmv_generated > 0 ? el.gmv_generated : '-'}
                        </td>
                        <td className="switchtd">
                          {" "}
                          <img
                            className="switch"
                            alt="switch-on"
                            src={el.is_active ? switchOn : switchOff}
                            onClick={() => onDisableDealsClick(el)}
                          />
                        </td>
                        <td>
                          {el.deal_type !== "RETURN_TRIP" && (
                            <Button
                              styleObj={actionButtonStyle}
                              label="Edit"
                              onButtonClick={() => onEditDealsClick(el.deal_id)}
                            />
                          )}
                            <Button
                              styleObj={actionButtonStyle}
                              label="Refresh"
                              onButtonClick={() => onRefreshDealClick(el)}
                            />
                        </td>
                      </tr>
                    ))}
              </tbody>
            </table>
            {dealsFilteredData && Boolean(dealsFilteredData.length) && (dealsFilteredData.length)>10 && (
              <div className="pagination">
                <TablePagination
                  pageNum={pageNum}
                  dataLength={dealsFilteredData && dealsFilteredData.length}
                  onPrevClick={onPrevClick}
                  onNextClick={onNextClick}
                  isInventoryView={true}
                  paginationLimit={paginationLimit}
                  onPageNumClick={onPageNumClick} 
                  dealPagination
                />
              </div>
            )}
          </div>
        }
      </div>
    ) : <></>
  );
};

export default OngoingDeals;
